import { useProjectSiteParams } from '@/shared/lib';

import { useGetProjectDataQuery } from '../api/layoutApi';

/** Project data of the project and site in the URL, already loaded by ProjectSiteLoader. */
export function useCurrentProjectData() {
  const { projectId, siteId } = useProjectSiteParams();
  const { data } = useGetProjectDataQuery({ projectId, siteId }, { skip: !projectId || !siteId });

  return data;
}
